import { useResolvedVoucherDiscount } from './useResolvedVoucherDiscount';
import { isConditionalDiscount } from './utils';

/**
 * Determines if we want to display price in the voucher bigger than main product price
 */
export const useHasStressOnVoucherDiscount = () => {
  const voucherDiscount = useResolvedVoucherDiscount();
  if (!voucherDiscount) {
    return false;
  }

  const isAbsoluteConditionalDiscount =
    isConditionalDiscount(voucherDiscount) &&
    voucherDiscount.discountType === 'Absolute';

  return !isAbsoluteConditionalDiscount;
};
